import Vue from 'vue';
import VueResizeText from 'vue-resize-text';

Vue.use(VueResizeText);
